<template>
  <q-dialog v-model="isOpenSync" @hide="$emit('update:advert', undefined)">
    <q-card>
      <q-card-section>
        <h6>Remove Advertisement</h6>
      </q-card-section>

      <q-card-section>
        <p>Are you sure you want to delete this advertisement?</p>

        <p v-if="error" class="text-negative">{{ error }}</p>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn v-close-popup flat color="grey" label="Cancel" />
        <q-btn color="negative" label="Delete" unelevated @click="deleteAd" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { getErrorMessage } from '@/utils';

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    advert: {
      type: Object,
      required: false,
      default: () => {},
    },
    onDeleteSuccess: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      error: undefined,
    };
  },

  computed: {
    isOpenSync: {
      get() {
        return this.isOpen;
      },
      set(value) {
        this.$emit('update:isOpen', value);
      },
    },
  },

  methods: {
    async deleteAd() {
      try {
        this.isLoading = true;
        await this.$axios.delete(`/admin/ad/${this.advert.id}`);

        this.onDeleteSuccess();
        this.isOpenSync = false;
      } catch (error) {
        this.error = getErrorMessage(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style></style>
